import {useMapContextValue} from '../context'

export const useMapComponents = () => {
  const mapContext = useMapContextValue()
  if (!mapContext) {
    console.error('Map context is not defined')
    return
  }
  return mapContext.components
}
